import React from 'react';
import { MotionWrapperStyles as S } from './MotionWrapper.styles';
import { useInView } from '@hooks/useInView';
import { rootMargin as _rootMargin } from '@helpers/animate';
const MotionWrapper = ({ isEditMode, threshold, rootMargin = _rootMargin, children, }) => {
    const [ref, inView] = useInView({
        rootMargin,
        threshold,
    }, false, isEditMode);
    return (React.createElement(S.Container, { "data-in-view": inView },
        React.createElement("div", { ref: ref }, children)));
};
export default MotionWrapper;
